import { useEffect, useRef } from 'react';
import { useToast } from '../common/ToastProvider';
import { SUBSCRIPTION_EXPIRED_EVENT, FEATURE_NOT_IN_PLAN_EVENT } from '../../api/apiClient';

const DEBOUNCE_MS = 10_000;
const FALLBACK = "Your society's MyCasa subscription has expired. The app is read-only — please inform your admin.";
const NOT_IN_PLAN = 'Not in your plan — ask your MyCasa agent to upgrade.';

const GlobalSubscriptionExpiredListener: React.FC = () => {
    const { showError } = useToast();
    const lastShownAt = useRef(0);

    useEffect(() => {
        const onExpired = (e: Event) => {
            const now = Date.now();
            if (now - lastShownAt.current < DEBOUNCE_MS) return;
            lastShownAt.current = now;
            const detail = (e as CustomEvent<string | undefined>).detail;
            showError(detail || FALLBACK);
        };
        const onNotInPlan = () => {
            const now = Date.now();
            if (now - lastShownAt.current < DEBOUNCE_MS) return;
            lastShownAt.current = now;
            showError(NOT_IN_PLAN);
        };
        window.addEventListener(SUBSCRIPTION_EXPIRED_EVENT, onExpired);
        window.addEventListener(FEATURE_NOT_IN_PLAN_EVENT, onNotInPlan);
        return () => {
            window.removeEventListener(SUBSCRIPTION_EXPIRED_EVENT, onExpired);
            window.removeEventListener(FEATURE_NOT_IN_PLAN_EVENT, onNotInPlan);
        };
    }, [showError]);

    return null;
};

export default GlobalSubscriptionExpiredListener;
